<div class="modal-header">
  <h5 class="modal-title">Modificar aerovale N°: {{ detalle.prefijo | aerovalePrefijo }}{{ detalle.numeroAerovale | aerovaleNumero }}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
  </button>
</div>
<div class="modal-body">
  <div class="mb-3 mx-4 row">
    <form [formGroup]="modificarForm" class="d-flex">
      <label for="clienteFormControl" class="col-sm-2 col-form-label">Cliente:</label>
      <div class="col-sm-8">
        <div *ngIf="!cargandoClientes" class="input-group">
          <input id="clienteFormControl" type="text" class="form-control" formControlName="clienteFormControl"
            [inputFormatter]="formatterCliente" [resultFormatter]="formatterCliente" (change)="confirmCliente()"
            [ngbTypeahead]="searchCliente" (selectItem)="selectCliente($event)"/>
        </div>
        <loading-text-spinner *ngIf="cargandoClientes" [error]="errorClientes" message="Obteniendo clientes..."
          color="primary">
        </loading-text-spinner>
        <div class="alert alert-danger"
          *ngIf="clienteFormControl.invalid && clienteFormControl.errors.required && (clienteFormControl.dirty || clienteFormControl.touched)">
          Requerido
        </div>
      </div>
    </form>
  </div>
</div>
<div class="modal-footer text-center">
  <button class="btn btn-primary" [disabled]="modificando || cargandoClientes || modificarForm.invalid" (click)="modificarAerovale()">
    <div *ngIf="!modificando" class="d-flex align-items-center">
    <span>Modificar</span>
    </div>
    <div *ngIf="modificando" class="d-flex align-items-center">
      <div class="spinner-border text-light spinner-border-sm" role="status"></div>
      <span>Modificando...</span>
    </div>
  </button>
  <button class="btn btn-secondary" (click)="modal.dismiss()" [disabled]="modificando">
    Cancelar</button>
</div>
